// extracted by mini-css-extract-plugin
module.exports = {"grid":"Home_grid__sUtIT","card":"Home_card__3lxb8","cardImage":"Home_cardImage__3HMJ3","cardTitle":"Home_cardTitle__1heoy"};